import { RequestStatus } from 'typed/api';
import { ActionType, Action } from 'typed/actions';
import { IReducer, networkActionReducer } from './';
import { Entity, IEntityReducerState, isNetworkArray, isSimpleArray, IEntityReducerCreator } from './entityReducers';
import { deepAssign, deepClone } from 'typed/utils';

const entityEditAllReducer: IEntityReducerCreator = <E extends Entity, T extends ActionType>(def: IEntityReducerState<E>, type: T): IReducer<any, Action<T>> => {
    const nr = networkActionReducer<T, E>(type);
    return function entityEditAllReducer(state: IEntityReducerState<E> | undefined = deepClone(def), action: Action<T>): IEntityReducerState<E> {
        if (action.type === type) {
            let data = isNetworkArray(state) ? state.Data : isSimpleArray(state) ? state : [state];

            data = deepAssign(data, data.map(item =>
                action.payload.entities.getByID(item.ID) ?
                    action.payload.status === RequestStatus.UNSYNCED ? action.payload.entities.getByID(item.ID) : nr(item, action) :
                    item
            ));

            return isNetworkArray(state) ? deepAssign(state, { Data: data }) : isSimpleArray(state) ? data : data[0];
        }
        return state;
    };
}

export default entityEditAllReducer;
